const resources = {
    relatedContentLabel: 'Related Content'
};

module.exports = function getResource(label) {
    return resources[label];
};
